import { render, staticRenderFns } from "./resumo-familia.vue?vue&type=template&id=305c47a4&scoped=true"
import script from "./resumo-familia.vue?vue&type=script&lang=js"
export * from "./resumo-familia.vue?vue&type=script&lang=js"
import style0 from "./resumo-familia.vue?vue&type=style&index=0&id=305c47a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "305c47a4",
  null
  
)

export default component.exports